<div class="main-content">
	<div class="col-md-12">
		<div class="container-fluid">
			<div class="row">
				<div [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='All Vendors', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='All Vendors'}" @grow>
					<app-all-vendors (viewData)="toggleFlipTest($event)"></app-all-vendors>
				</div>
				<div [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='Top 100 Vendors', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='Top 100 Vendors'}" @grow>
					<app-vendordash-top-100 (viewData)="toggleFlipTest($event)"></app-vendordash-top-100>
				</div>
				<div [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='Over Due Vendors', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='Over Due Vendors'}" @grow>
					<app-vendordash-overdue (viewData)="toggleFlipTest($event)"></app-vendordash-overdue>
				</div>
				<div [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='Payments', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='Payments'}" @grow>
					<app-vendordash-payments (viewData)="toggleFlipTest($event)"></app-vendordash-payments>
				</div>
				<div [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='Ready To Invoice', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='Ready To Invoice'}" @grow>
					<app-vendordash-invoice (viewData)="toggleFlipTest($event)"></app-vendordash-invoice>
				</div>
				<div [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='Ready To Pay', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='Ready To Pay'}" @grow>
					<app-vendordash-ready-to-pay (viewData)="toggleFlipTest($event)"></app-vendordash-ready-to-pay>
				</div>
				<div [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='Outstanding GRNs', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='Outstanding GRNs'}" @grow>
					<app-vendordash-outstanding-grns (viewData)="toggleFlipTest($event)"></app-vendordash-outstanding-grns>
				</div>
				<div [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='Partial Receipts', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='Partial Receipts'}" @grow>
					<app-vendordash-partial-receipts (viewData)="toggleFlipTest($event)"></app-vendordash-partial-receipts>
				</div>
				<div [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='Invoice Issues', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='Invoice Issues'}" @grow>
					<app-vendordash-invoice-issues (viewData)="toggleFlipTest($event)"></app-vendordash-invoice-issues>
				</div>
				<div [ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='Open Purchase Orders', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='Open Purchase Orders'}" @grow>
					<app-vendordash-open-pos (viewData)="toggleFlipTest($event)"></app-vendordash-open-pos>
				</div>
			</div>
		</div>
	</div>
</div>
